import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import SearchBox from 'components/SearchBox';
import DialogContent from '@material-ui/core/DialogContent';
import TransactionSelectList from 'components/TransactionSelectList';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import QButton from 'components/QButton';
import QPureComponent from 'QPureComponent';
import { getLesserBilledTransactions } from 'data/transactionList/selectors';

const styles = (theme) => ({
  dialogRoot: {
    overflow: 'scroll',
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '24px 24px 0',
    height: 'fit-content',
    position: 'relative',
    minHeight: 100,
    backgroundColor: theme.palette.greyScale[6],
  },
  subtitle: {
    paddingTop: 4,
  },
  closeButton: {
    position: 'absolute',
    top: 12,
    right: 12,
    padding: 12,
  },
  searchBar: {
    height: 40,
    paddingLeft: 4,
    borderRadius: 4,
    backgroundColor: theme.palette.greyScale[7],
    border: `1px solid ${theme.palette.greyScale[4]}`,
    margin: 'auto 0 0 4px',
    '&.open': {
      width: 220,
    },
  },
  searchInput: {
    fontSize: '14px',
    lineHeight: 1.43,
    fontWeight: 'normal',
    color: '#000000',
  },
  greyGrid: {
    padding: '0px 14px',
  },
  buttonBottoms: {
    display: 'flex',
    flex: '0 0 auto',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 68,
    paddingBottom: 14,
    paddingLeft: 24,
    paddingRight: 24,
  },
  manualLine: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: '#666666',
  },
  manualButton: {
    color: theme.palette.secondary.main,
    marginLeft: 6,
  },
  disabledSave: {
    color: `${theme.palette.greyScale[7]} !important`,
    opacity: 0.5,
  },
});

class SelectTransactionDialog extends QPureComponent {

  constructor(props) {
    super(props);
    this.state = {};
  }

  // This is the function by which a transaction selected from the virtualList in ScheduleList component is stored in
  // this component's state. Couldn't think of a cleaner way to back-pass updates to state. The nested ID checks are
  // used to grab parent ID values, as each transaction row has many child components, but the ID we need is in the
  // parent row.
  selectTxn = (event) => {
    const selectTxn = JSON.parse(event.currentTarget.id);
    const currentTxn = this.state.selectedTxn;
    if (currentTxn && (currentTxn.id === selectTxn.id)) {
      this.setState({ selectedTxn: null });
    } else {
      this.setState({ selectedTxn: selectTxn });
    }
  };

  onClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  onExit = () => {
    this.setState({
      selectedTxn: null,
      search: null,
    });
  };

  render() {
    const { props } = this;
    const { classes, selectorProps, title, headline, buttonText, disableAdd, subtitle } = props;

    // For backwards compatibility, the default selector is for scheduled transactions
    const transactionListSelector = props.transactionListSelector || getLesserBilledTransactions;
    return (
      <Dialog
        title={title || "Add a Bill or Paycheck"}
        open={Boolean(props.open)}
        fullWidth
        maxWidth="md"
        className={classes.dialogRoot}
        onClose={this.onClose}
        onExit={this.onExit}
      >
        <div className={classes.title}>
          <ListItemText
            primary={ headline || 'Select a transaction to make recurring' }
            secondary={ subtitle }
            primaryTypographyProps={{ variant: 'h5' }}
            classes={{
              secondary: classes.subtitle,
            }}
          />

          <IconButton
            className={classes.closeButton}
            aria-label="Close"
            id="dlg-close"
            onClick={() => this.onClose()}
          >
            <CloseIcon/>
          </IconButton>

          <SearchBox
            onSearch={(search) => {
              this.setState({ search })
            }}
            autoSearch={false}
            collapsable={false}
            initialValue={this.state.search}
            placeholder="Search Transactions"
            classes={{
              root: classes.searchBar,
              input: classes.searchInput,
            }}
          />
        </div>
        <DialogContent className={classes.greyGrid}>
          <TransactionSelectList
            clickFunc={this.selectTxn}
            highlight={this.state.selectedTxn && this.state.selectedTxn.id}
            filter={this.state.search}
            onReset={() => this.setState({ search: null} )}
            transactionListSelector={transactionListSelector}
            selectorProps={selectorProps}
          />
        </DialogContent>
        <div className={classes.buttonBottoms}>
          <QButton
            type="submit"
            id="create-transaction"
            variant="contained"
            disabled={!this.state.selectedTxn}
            onClick={() => props.onTransactionSelected && props.onTransactionSelected(this.state.selectedTxn)}
            width={172}
            style={{ marginRight: 10 }}
          >
            { buttonText || 'CREATE' }
          </QButton>

          {!disableAdd &&
            <Typography variant="body2" className={classes.manualLine}>
              {"Couldn't Find?"}
              <Button
                className={classes.manualButton}
                id="add-manually-transaction"
                onClick={() => props.onTransactionSelected && props.onTransactionSelected()}
              >
                ADD MANUALLY
              </Button>
            </Typography>
          }
        </div>
      </Dialog>
    );
  }
}

SelectTransactionDialog.propTypes = {
  classes: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onTransactionSelected: PropTypes.func,
  transactionListSelector: PropTypes.func,
  selectorProps: PropTypes.object,
  title: PropTypes.string,
  headline: PropTypes.string,
  subtitle: PropTypes.string,
  buttonText: PropTypes.string,
  disableAdd: PropTypes.bool,
};

export default withStyles(styles)(SelectTransactionDialog);
